// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WiseLoginButton_componentWrapper__uqFKG","authButton":"WiseLoginButton_authButton__RVp-F","popoverPaper":"WiseLoginButton_popoverPaper__rAVhq"};